import { useEffect } from "react";
import "./landing.css";
import { PowerOn } from "./PowerOn";
import { Hero } from "./Hero";
import { ConsoleWall } from "./ConsoleWall";
import { HowToPlay } from "./HowToPlay";
import { FeatureStrip } from "./FeatureStrip";
import { Showcase } from "./Showcase";
import { Footer } from "./Footer";

/**
 * The public marketing page, shown when the app is opened in a normal browser
 * (i.e. NOT inside Discord). Composed of one component per section.
 */
export default function LandingPage() {
  // app.css pins <body> to overflow:hidden / height:100vh for the in-Discord
  // activity. The landing page needs to scroll, so we flip a class on <body>
  // while mounted and restore it on unmount.
  useEffect(() => {
    document.body.classList.add("landing-active");
    document.title = "Retro games, right inside Discord — by GoatSquad Studios";
    return () => document.body.classList.remove("landing-active");
  }, []);

  return (
    <div className="lp-root">
      <PowerOn />

      {/* Subtle studio attribution — small GoatSquad mark, top-left, links back
          to the studio. Kept low-opacity so it reads as a quiet credit, not a
          header. Hidden on very small screens to avoid crowding the hero. */}
      <a
        href="https://goatsquadstudios.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="A Goat Squad Studios project"
        className="absolute left-6 top-6 z-10 hidden opacity-85 transition-opacity hover:opacity-100 sm:inline-flex"
      >
        <img
          src="/brand/icon-white.svg"
          alt="Goat Squad Studios"
          className="h-10 w-auto sm:h-12"
          width={42}
          height={48}
        />
      </a>

      {/* Layered atmosphere: scanlines + grain + dot-grid + vignette */}
      <div className="lp-atmos lp-scanlines" aria-hidden />
      <div className="lp-atmos lp-dots" aria-hidden />
      <div className="lp-atmos lp-grain" aria-hidden />
      <div className="lp-atmos lp-vignette" aria-hidden />

      <main className="relative z-[1]">
        <Hero />
        <ConsoleWall />
        <HowToPlay />
        <FeatureStrip />
        <Showcase />
        <Footer />
      </main>
    </div>
  );
}
